import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren
} from '@angular/core';
import { isEqual as _isEqual } from 'lodash';

import { MAP_TRIGGER } from '../../+state/app-state/app-state.models';
import { SearchResult } from '../../+state/service-locator/service-locator.models';
import { PagerService } from '../../services/pager.service';

@Component({
  selector: 'drp-results-wrapper',
  templateUrl: './results-wrapper.component.html',
  styleUrls: ['./results-wrapper.component.scss'],
  standalone: false
})
export class ResultsWrapperComponent implements OnInit, OnChanges {
  @Input() shopSearchResults: SearchResult[];
  @Input() selectedShop: SearchResult;
  @Input() isPartner: boolean;
  @Output() initialize = new EventEmitter<any>();
  @Output() setCurrentPage = new EventEmitter<any>();
  @Output() selectedCard = new EventEmitter<any>();
  @Output() mapEvent = new EventEmitter<any>();
  @ViewChildren('card') card: QueryList<ElementRef>;
  private allItems: any[];

  currentPageNumber = 1;
  pager: any = {};
  pagedItems: any[];

  constructor(
    private pagerService: PagerService,
    private elementRef: ElementRef
  ) {}

  ngOnInit() {
    this.setPage(1);
    this.initialize.emit(this.shopSearchResults.length);
  }

  ngOnChanges(changes: SimpleChanges) {
    // eslint-disable-next-line guard-for-in
    for (const propName in changes) {
      const change = changes[propName];
      if (!change.isFirstChange()) {
        if (propName === 'shopSearchResults') {
          this.setPage(1);
        }
      }
    }

    const index =
      this.shopSearchResults.findIndex(res => {
        return _isEqual(res, this.selectedShop);
      }) + 1;
    if (changes.selectedShop && this.selectedShop && this.card) {
      const currentCard = this.card.toArray();
      currentCard[(index - 1) % 10].nativeElement.scrollIntoView(false);
    }
  }
  /**
   * When user paginations update map trigger and set new current pages
   * @param page
   */
  handlePagination(page: number) {
    this.mapEvent.emit(MAP_TRIGGER.ON_PAGINATE);
    this.setPage(page);
  }
  setPage(page: number) {
    this.currentPageNumber = page;
    this.pager = this.pagerService.getPager(this.shopSearchResults.length, page);

    this.pagedItems = this.shopSearchResults.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.setCurrentPage.emit({
      pageNum: page,
      pageItems: this.pagedItems
    });
  }

  selectShop(shop) {
    this.selectedCard.emit(shop);
  }

  getFirstOfPg(): number {
    if (this.pager.currentPage === 1) {
      return 1;
    } else {
      return (this.pager.currentPage - 1) * 10 + 1;
    }
  }

  getLastOfPg(): number {
    if (this.pager.currentPage === this.pager.totalPages) {
      return this.shopSearchResults.length;
    } else {
      return this.pager.currentPage * 10;
    }
  }
}
